import { Component } from '@angular/core';
import {DashboardComponent} from './features/dashboard/dashboard.component';


@Component({
  standalone: true,
  selector: 'via-root',
  imports: [DashboardComponent],
  templateUrl: './dashboard-app.component.html',
  styleUrl: './dashboard-app.component.scss',
})
export class DashboardApp {
}
